type BorderLoaderProps = {
  className?: string;
  color?: string;
};

export const BorderLoader = ({
  className = "",
  color = "#FF5E00",
}: BorderLoaderProps) => {
  return (
    <svg
      className={`absolute -inset-1 w-[calc(100%+8px)] h-[calc(100%+8px)] pointer-events-none ${className}`}
      viewBox="0 0 100 40"
      preserveAspectRatio="none"
    >
      <rect
        x="2"
        y="2"
        width="96"
        height="36"
        rx="6"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeDasharray="20 234"
        strokeLinecap="round"
        style={{ filter: "blur(1.5px)" }}
        className="border-loader"
      />
      <rect
        x="2"
        y="2"
        width="96"
        height="36"
        rx="6"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeDasharray="20 234"
        strokeLinecap="round"
        className="border-loader"
      />
    </svg>
  );
};